import React from 'react';
import { Scale, Shield, Globe } from 'lucide-react';

const Legal: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-ivory-50 to-stone-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 animate-fade-in">
          <Scale className="h-12 w-12 text-copper mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-steel mb-2">Mentions Légales</h1>
          <p className="text-stone">Informations légales et réglementaires</p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 animate-slide-up space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-steel mb-4 flex items-center">
              <Globe className="h-6 w-6 mr-2 text-copper" />
              Identification du site
            </h2>
            <div className="space-y-2 text-steel">
              <p><strong>Nom du site :</strong> MemoMundi.ai</p>
              <p><strong>Concept :</strong> Musée vivant des conversations IA</p>
              <p><strong>Statut :</strong> Prototype en développement</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-steel mb-4 flex items-center">
              <Shield className="h-6 w-6 mr-2 text-copper" />
              Protection intellectuelle
            </h2>
            <div className="bg-ivory/50 p-6 rounded-lg">
              <div className="space-y-3 text-steel">
                <p className="font-medium">Concept déposé et protégé :</p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-copper rounded-full"></div>
                    <span>INPI (France)</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-sky rounded-full"></div>
                    <span>Copyright.eu</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-rose rounded-full"></div>
                    <span>OMPI (en cours)</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-steel mb-4">Marques déposées</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
              <div className="bg-sky/10 p-3 rounded text-center text-sky-800">MMD Veritas™</div>
              <div className="bg-rose/10 p-3 rounded text-center text-rose-800">MemoStamp™</div>
              <div className="bg-copper/10 p-3 rounded text-center text-copper-800">Companion ID™</div>
              <div className="bg-stone/10 p-3 rounded text-center text-stone-800">Praesentia™</div>
              <div className="bg-steel/10 p-3 rounded text-center text-steel-800">Like IA™</div>
              <div className="bg-amber/10 p-3 rounded text-center text-amber-800">Instance Interact™</div>
              <div className="bg-purple/10 p-3 rounded text-center text-purple-800">Memory™</div>
              <div className="bg-green/10 p-3 rounded text-center text-green-800">Modules MMD™</div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-steel mb-4">Données personnelles</h2>
            <div className="text-steel space-y-2">
              <p>Ce prototype respecte les réglementations en vigueur concernant la protection des données personnelles.</p>
              <p className="text-sm text-stone">
                Version complète de la politique de confidentialité disponible lors du lancement officiel.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-steel mb-4">Hébergement</h2>
            <div className="text-steel">
              <p>Ce prototype est hébergé sur des serveurs conformes aux standards européens de sécurité.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Legal;